import request from "@/utils/request.js"
//获取全部订单
export const getOrderList_api=params=>{
    return  request({
      method: 'get',
      url: 'api/v1/store/order/list',
      params,
    });
    } 
  //获取伊藤全部订单
export const VgetOrderList_api=params=>{
  return  request({
    method: 'get',
    url: 'api/v2/store/order/list',
    params,
  });
  }
//获取待领取订单
export const getOrderPendingList_api=params=>{
    return  request({
      method: 'get',
      url: 'api/v1/store/order/pendingList',
      params,
    });
    }
    
//获取伊藤待领取订单
export const VgetOrderPendingList_api=params=>{
  return  request({
    method: 'get',
    url: 'api/v2/store/order/pendingList',
    params,
  });
  }
  
//获取已退款订单
export const getOrderRefundList_api=params=>{
    return  request({
      method: 'get',
      url: 'api/v1/store/order/refundList',
      params,
    });
    }
//获取伊藤已退款订单
export const VgetOrderRefundList_api=params=>{
  return  request({
    method: 'get',
    url: 'api/v2/store/order/refundList',
    params,
  });
  }
  
//获取已领取订单
export const getOrderReceivedList_api=params=>{
    return  request({
      method: 'get',
      url: 'api/v1/store/order/receivedList',
      params,
    });
    }
//获取伊藤已领取订单
export const VgetOrderReceivedList_api=params=>{
  return  request({
    method: 'get',
    url: 'api/v2/store/order/receivedList',
    params,
  });
  }
  

    

//获取订单评价
export const getOrderCommen_api=params=>{
  return  request({
    method: 'get',
    url: 'api/v1/store/order/comment',
    params,
  });
  }
  
//获取出库记录
export const goodRecord_api=params=>{
  return  request({
    method: 'get',
    url: 'api/v1/store/order/goodRecord',
    params,
  });
  }

//获取新订单
export const orderPush_api=params=>{
  return  request({
    method: 'get',
    url: 'api/v1/store/order/push',
    params,
  });
  }